<template>
    <div>
        <disposition-list/>
    </div>
</template>

<script>
import DispositionList from './DispositionList';

export default {
    name:       'DispositionContainer',
    components: {
        DispositionList
    }
}
</script>
